import MomentUtils from "@date-io/moment";
import { MuiThemeProvider } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { observer } from "mobx-react";
import moment from "moment";
import "moment/locale/de";
import * as React from "react";
import { RawIntlProvider } from "react-intl";
import { AppRouter } from "./components/app/router/AppRouter";
import { debug } from "./components/util/debug";
import { BASE_NAME, DAL_DOMAIN } from "./config";
import { intl, t } from "./i18n/util";
import { authStore } from "./stores/AuthStore";
import { generalStore } from "./stores/GeneralStore";
import { hrStore } from "./stores/HrStore";
import { THEME } from "./theme/ThemeStore";
import { notify } from "./components/util/notifications";

function debugLocalhost() {
    const location = window.location;
    const credentials = authStore.credentials;
    const target =
        "http://localhost:3000" +
        location.pathname.replace(BASE_NAME, "") +
        location.search +
        `#access_token=${credentials?.access_token}&refresh_token=${credentials?.refresh_token}`;
    debug.log("### redirecting to", target);
    window.open(target, "_self");
}

function debugNotification() {
    notify(t("notifications.title"), t("notifications.message", { notifications: 5 }));
}

function debugToggleBranding() {
    THEME.toggleBranding();
}

const App: React.FunctionComponent = observer(() => {
    (window as any).debugLocalhost = debugLocalhost;
    (window as any).debugNotification = debugNotification;
    (window as any).debugToggleBranding = debugToggleBranding;

    const themeName = THEME.THEME_NAME;

    React.useEffect(() => {
        let link: any = document.querySelector("link[rel~='icon']");

        if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.getElementsByTagName("head")[0].appendChild(link);
        }

        if (document.domain === DAL_DOMAIN) {
            link.href = `${BASE_NAME}/favicon_dal.ico`;
            document.title = t("document.title.dal");
        } else {
            link.href = `${BASE_NAME}/favicon_aaa.png`;
            document.title = t("document.title.aaa");
        }

        if (document.domain === DAL_DOMAIN && themeName === "aaa") {
            THEME.toggleBranding();
        }
    }, [themeName]);

    // will be activated when keys get english translation
    // React.useEffect(() => {
    //     const browserLanguage = navigator.language.substr(0, 2);

    //     if (browserLanguage !== "de") {
    //         setLocale("en");
    //     }
    // }, []);

    moment.locale(generalStore.locale);

    const isRehydrated = authStore.isRehydrated && hrStore.isRehydrated;

    if (!isRehydrated) {
        return null;
    }

    return (
        <MuiPickersUtilsProvider locale={generalStore.locale} utils={MomentUtils}>
            <MuiThemeProvider theme={THEME.THEME}>
                <RawIntlProvider value={intl} key={generalStore.locale}>
                    <THEME.GlobalCSS />
                    <AppRouter />
                </RawIntlProvider>
            </MuiThemeProvider>
        </MuiPickersUtilsProvider>
    );
});

export default App;
